import React, { useState, useEffect, useRef } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { motion, AnimatePresence, useAnimation, color } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './home.css'; // Make sure this CSS file is correctly linked
import Hero from '../hero/Hero'; // Assuming Hero.js exists
import headerBgImage from './bgmockupdheer.png'
import logoImage from './bglogomockup.png';
import one from "../../NFC Assets/Cards/6.png"
import two from "../../NFC Assets/Cards/7.png"
import three from "../../NFC Assets/Cards/8.png"

// Import Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faSignal, faWifi, faBatteryFull, faPhone, faEnvelope, faGlobe, faFileLines, faCloud, faAt, faDraftingCompass
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookMessenger, faWhatsapp, faInstagram, faFacebookF, faLinkedinIn, faYoutube, faXTwitter
} from '@fortawesome/free-brands-svg-icons';

// --- IMAGE ASSETS ---
// The error means these files were not found.
// Please ensure your files are located at:
// src/assets/img/13.png
// src/assets/img/12.png
// src/assets/img/10.png  <-- ERROR WAS HERE
// src/assets/img/11.jpg
// import image13 from './../../assets/img/13.png';
import image12 from './../../NFC Assets/Cards/Gold Transparent Card.png';
import image10 from '../../NFC Assets/Cards/Gold Transparent Card.png'; // Make sure this file exists at src/assets/img/10.png
import image11 from './../../assets/img/999.png'; // Make sure this file exists at src/assets/img/11.jpg
import image1 from '../../NFC Assets/Cards/GoldTransparentone.png';
import image2 from '../../NFC Assets/Cards/SilverTransparent.png'
import image5 from "./Black 05.png"
import mockup from "../../NFC Assets/NFC Slider Video/1-min.png"
import Brand from "../../NFC Assets/NFC Slider Video/Brand.png"
import NFC from "../../NFC Assets/NFC Slider Video/NFC.png"
import featureVideo from './../../assets/img/22.mp4'

// --- THEME DEFINITION (ENHANCED & MERGED) ---
const theme = {
  colors: {
    primary: '#0A7CFF',
    primaryDarker: '#0056b3',
    secondary: '#00E6A4',
    secondaryDarker: '#00b383',
    accent: '#FF4081',
    accentDarker: '#c2185b',

    dssBlue: '#00A9E0', // Retained name: nownfc branding will use this theme color
    dssMediumBlue: '#0095C8', // Retained name
    dssDarkBlue: '#0077B6', // Retained name
    dssGradient: 'linear-gradient(135deg, #00A9E0 0%, #0077B6 100%)', // Retained name
    dssFooterGradient: 'linear-gradient(135deg, #121720 0%, #181e28 100%)',

    text: '#1A202C',
    textLight: '#5A6B7B',
    textAgainstDark: '#000000',
    textMuted: '#6c757d',

    background: '#FFFFFF',
    lightGray: '#F8F9FA',
    mediumGray: '#DEE2E6',
    darkSurface: '#10141D',
    dssBackgroundColor: '#F0F2F5', // Retained name
    dssSectionLightGrayBg: '#F8F9FA', // Retained name


    glassBg: 'rgba(255, 255, 255, 0.75)',
    darkGlassBg: 'rgba(16, 20, 29, 0.80)',
    shadow: 'rgba(0, 0, 0, 0.08)',
    shadowDark: 'rgba(0, 0, 0, 0.15)',
    cardShadowLight: '0 5px 15px rgba(0, 0, 0, 0.07)',
    cardShadowMedium: '0 10px 30px rgba(0, 0, 0, 0.10)',
    cardShadowStrong: '0 15px 45px rgba(0, 0, 0, 0.12)',
    phoneShadow: '0 20px 50px rgba(0, 70, 120, 0.22)',


    gold: '#FFD700',
    silver: '#B0BEC5',
    blackMatte: '#212529',
  },
  fonts: {
    main: "'Inter', sans-serif",
    heading: "'Poppins', sans-serif",
  },
  spacing: {
    xs: '8px', sm: '16px', md: '24px', lg: '48px', xl: '80px', xxl: '120px',
    sectionPaddingDesktop: '100px 60px',
    sectionPaddingMobile: '70px 24px',
    dssSectionPadding: '100px 40px', // Retained name for layout consistency
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    smallMobile: '480px',
  },
  borderRadius: '18px',
  dssBorderRadius: '12px', // Retained name for specific border radius style
  transitions: {
    default: '0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
    fast: '0.25s ease-out',
    smooth: '0.5s cubic-bezier(0.165, 0.84, 0.44, 1)',
  },
  motion: {
    spring: { type: 'spring', stiffness: 260, damping: 28 },
    springQuick: { type: 'spring', stiffness: 380, damping: 30 },
    reveal: {
      hidden: { opacity: 0, y: 50, scale: 0.97 },
      visible: (i = 0) => ({
        opacity: 1, y: 0, scale: 1,
        transition: { delay: i * 0.08, duration: 0.7, ease: [0.6, -0.05, 0.01, 0.99] },
      }),
    },
    textRevealContainer: {
      hidden: { opacity: 1 },
      visible: {
        opacity: 1,
        transition: { staggerChildren: 0.035, delayChildren: 0.15 }
      }
    },
    textRevealLetter: {
      hidden: { opacity: 0, y: 20, rotateX: -25, filter: 'blur(2px)' },
      visible: { opacity: 1, y: 0, rotateX: 0, filter: 'blur(0px)', transition: { duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99] }}
    }
  },
};

// --- IMAGE PLACEHOLDERS & ASSETS ---
const dssDashboardMockupUrl = mockup; // Retained var name
const dssGifUrl = "https://cdn.prod.website-files.com/5e26302469ca1d0fbae4a601/620ff085ccf8873e92c91535_Stop%20Motion%20NFC%20white.gif"; // Retained var name

const strongerConnectionPhoneImages = {
    profile: one,
    gallery: two,
    video: three,
};

// --- Subtle Geometric Background SVG ---
const SubtleBgPatternFixed = () => (
  <div className="subtle-bg-pattern-fixed">
    <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="subtlePattern" patternUnits="userSpaceOnUse" width="60" height="60" patternTransform="scale(1) rotate(45)">
          <path d="M0 15 L15 0 L30 15 L15 30 Z M30 45 L45 30 L60 45 L45 60 Z" strokeWidth="1" stroke="#707080" fill="none"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#subtlePattern)" />
    </svg>
  </div>
);

const GlobalNoiseOverlay = () => <div className="global-noise-overlay"></div>;


// --- SVG ICONS (MERGED) ---
const Icon = ({ name, size = 24, color, style: propStyle, className, viewBox = "0 0 24 24" }) => {
  const currentTheme = useTheme();

  const iconPaths = {
    menu: <path d="M3 12h18M3 6h18M3 18h18" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>,
    close: <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>,
    nfcSignal: <><path d="M14.5 10.5C14.5 9.12 13.38 8 12 8C10.62 8 9.5 9.12 9.5 10.5V13.5C9.5 14.88 10.62 16 12 16C13.38 16 14.5 14.88 14.5 13.5V10.5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.5 9C17.5 7.07 15.93 5.5 14 5.5C12.07 5.5 10.5 7.07 10.5 9V15C10.5 16.93 12.07 18.5 14 18.5C15.93 18.5 17.5 16.93 17.5 15V9Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M20.5 7.5C20.5 5.29 18.71 3.5 16.5 3.5C14.29 3.5 12.5 5.29 12.5 7.5V16.5C12.5 18.71 14.29 20.5 16.5 20.5C18.71 20.5 20.5 18.71 20.5 16.5V7.5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></>,
    checkCircle: <><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M9.00005 12L10.8134 13.8133L15 9.62668" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></>,
    palette: <><path d="M12 21.0001C16.9706 21.0001 21 16.9706 21 12.0001C21 7.02952 16.9706 3.00006 12 3.00006C7.02944 3.00006 3 7.02952 3 12.0001C3 16.9706 7.02944 21.0001 12 21.0001Z" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 21.0001C12 18.0001 12 15.0001 9.5 13.0001C7 11.0001 5.5 10.5001 4 9.00006C2.5 7.50006 2 6.00006 2 6.00006" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M16.5 3.41016C14.5 6.41016 14 9.00008 14 12.0001C14 14.0001 14.5 15.5001 15.5 17.0001" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/></>,
    tap: <><path d="M18.7256 10.4629C18.7256 10.4629 20.1686 11.0119 20.8166 11.7859C21.8106 12.9869 21.4706 14.8349 20.0596 15.7229L16.8936 17.8889C16.0756 18.4449 15.0006 18.3389 14.3016 17.6399L10.0146 13.3519C9.31558 12.6529 9.20958 11.5779 9.76558 10.7599L11.9316 7.59391C12.8196 6.18291 14.6676 5.84291 15.8686 6.83691C16.6426 7.48491 17.1916 8.92791 17.1916 8.92791"/><path d="M12.9688 13.6914L10.0148 10.7374"/><path d="M7.19141 20.3516C7.19141 20.3516 4.80841 19.5006 3.64841 17.8736C2.40441 16.1216 3.02241 13.8046 4.72041 12.6196L8.80841 9.66565" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></>,
    bolt: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>,
    business: <><path d="M3 21h18"/><path d="M5 21V5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V21"/><path d="M9 10V12"/><path d="M9 15V17"/><path d="M15 10V12"/><path d="M15 15V17"/><path d="M12 8V21"/></>,
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>,
    metal: <><rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="1.5"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18" strokeWidth="1.5"/></>,
    pvc: <><rect x="2" y="7" width="20" height="10" rx="1" strokeWidth="1.5"/><path d="M6 10h4M6 14h8" strokeWidth="1.5"/></>,
    cardStack: <><rect x="2" y="10" width="20" height="12" rx="2" ry="2" strokeWidth="1.5"/><path d="M6 6h16a2 2 0 012 2v10M10 2h12a2 2 0 012 2v10" strokeWidth="1.5"/></>,
    truck: <><rect x="1" y="3" width="15" height="13" rx="1" strokeWidth="1.5"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" strokeWidth="1.5"/><circle cx="5.5" cy="18.5" r="2.5" strokeWidth="1.5"/><circle cx="18.5" cy="18.5" r="2.5" strokeWidth="1.5"/></>,
    settings: <><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42.12-.64l2 3.46c.12.22.39.3.61.22l2.49 1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49.42l.38-2.65c.61-.25 1.17-.59 1.69.98l2.49 1c.23.09.49 0 .61.22l2-3.46c.12-.22-.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></>,
    linkedin: <><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></>,
    twitter: <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>,
    instagram: <><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></>,
    arrowRight: <path d="M5 12h14m-7-7l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>,
    qrCode: <><path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm0 8h.01M13 13h8v8h-8v-8zm2 2h4v4h-4v-4z"/></>,
    check: <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor" stroke="none"/>,
    customize: <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor" stroke="none"/>,
    dashboard: <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor" stroke="none"/>,
    scan: <><path d="M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 14H5V5h14v14zM7 7h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM7 15h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z" fill="currentColor" stroke="none"/></>,
    link: <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" fill="currentColor" stroke="none"/>,
    nfc: <><path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM11.29 7.71 8.5 10.5l2.79 2.79c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.62 11H15c.55 0 1-.45 1-1s-.45-1-1-1h-4.38l1.08-1.08c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0z" fill="currentColor" stroke="none"/></>,
    qr: <path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm-6 8h8v-8h-8v8zm2-6h4v4h-4v-4z" fill="currentColor" stroke="none"/>,
    scratch: <><path d="M20.5 3.95a.75.75 0 0 0-1.061-.001L3.95 19.439a.75.75 0 0 0 .001 1.061l.53.53a.75.75 0 0 0 1.061-.001L20.999 5.561a.75.75 0 0 0-.001-1.061l-.53-.531zm-5.743 3.808l-2.828 2.828-1.06-1.06 2.828-2.828 1.06 1.06zM12 2C6.48 2 2 6.48 2 2s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" stroke="none"/></>,
    secure: <><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6-3.5c1.93 0 3.5 1.57 3.5 3.5V8H8.5V6c0-1.93 1.57-3.5 3.5-3.5zm6 13.5H6V10h12v8z"/><path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill="currentColor" stroke="none"/></>,
    nownfcLogoIconSVG: <path d='M50 10 C30 10, 10 30, 10 50 C10 70, 30 90, 50 90 C70 90, 90 70, 90 50 C90 30, 70 10, 50 10 Z M50 20 C61.0457 20 70 28.9543 70 40 C70 51.0457 61.0457 60 50 60 C38.9543 60 30 51.0457 30 40 C30 28.9543 38.9543 20 50 20 Z M50 65 C63.8071 65 75 76.1929 75 90 L25 90 C25 76.1929 36.1929 65 50 65 Z' fill='currentColor'/>,
    facebook: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
    youtube: <path d="M21.58 7.19c-.23-.86-.91-1.54-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.42c-.86.23-1.54.91-1.77 1.77C2 8.75 2 12 2 12s0 3.25.42 4.81c.23.86.91 1.54 1.77 1.77C5.75 19 12 19 12 19s6.25 0 7.81-.42c.86.23 1.54-.91 1.77-1.77C22 15.25 22 12 22 12s0-3.25-.42-4.81zM9.75 15.02V8.98l5.74 3.02-5.74 3.02z"/>,
    tiktok: <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.73v2.1h-2.01c-.04.88-.2 1.75-.46 2.59-.26.84-.58 1.64-.97 2.39-.41.77-.87 1.51-1.39 2.18-.52.66-1.09 1.29-1.72 1.84-.62.55-1.29 1.04-2 1.47-.69.42-1.42.77-2.17 1.05V14.88c.89-.19 1.75-.56 2.53-1.08.79-.53 1.48-1.19 2.04-1.95.57-.75 1.01-1.6 1.32-2.49.3-.89.46-1.84.49-2.83h-2.12V0H12.53v.02z"/>,
    pinterest: <path d="M12 2C6.48 2 2 6.48 2 12c0 4.02 2.67 7.41 6.24 8.66-.06-.28-.11-.79-.11-1.19 0-1.03.24-2.1.7-2.99.39-.75.89-1.36 1.51-1.9.3-.26.48-.55.48-.86 0-.6-.33-1.09-.78-1.09-.33 0-.59.25-.59.56 0 .24.12.49.28.71.03.05.03.07.02.12-.06.21-.17.43-.17.66 0 .46.23.86.65.86.55 0 1.01-.55 1.01-1.34 0-.99-.64-1.71-1.47-1.71-.99 0-1.78.77-1.78 1.83 0 .51.2.86.45 1.13.06.07.07.09.05.18-.09.38-.29.78-.29 1.12 0 .44.13.79.53.79.29 0 .43-.33.43-.59 0-.34-.2-.68-.28-.93-.03-.09.03-.15.09-.12.56.24 1.06.78 1.06 1.61 0 1.01-.69 1.84-1.74 1.84-.85 0-1.57-.65-1.57-1.55 0-.69.43-1.13.68-1.43.01-.01.01-.02 0-.03-.29-.29-.45-.65-.45-1.13 0-.9.63-1.97 2.03-1.97 1.63 0 2.78 1.18 2.78 2.59 0 1.52-.97 2.73-2.33 2.73-.49 0-.94-.25-.94-.55 0-.29.19-.48.34-.63.2-.19.37-.34.37-.58 0-.41-.22-.75-.63-.75-.52 0-.9.45-.9.99 0 .3.07.51.17.68L9.36 17c-.2.78-.9 1.78-2.06 2.45C8.57 21.08 10.23 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>,
  };

  const iconColorResolved = color || (currentTheme ? currentTheme.colors.text : 'currentColor');
  const filledIconNames = ['check', 'customize', 'dashboard', 'scan', 'link', 'nfc', 'qr', 'scratch', 'secure', 'nownfcLogoIconSVG', 'facebook', 'youtube', 'tiktok', 'pinterest'];

  const iconStroke = filledIconNames.includes(name) ? 'none' : iconColorResolved;
  const iconFill = filledIconNames.includes(name) ? iconColorResolved : 'none';

  if (['phone', 'email', 'website', 'address', 'instagramOld', 'twitterOld', 'linkedinOld'].includes(name)) {
    const textIcons = {
        phone: '📞', email: '📧', website: '🌐', address: '📍',
        instagramOld: 'Ig', twitterOld: 'Tw', linkedinOld: 'In',
    };
    const style = {fontSize: `${size*0.7}px`, fontWeight: 600, color: iconColorResolved, ...propStyle, fontFamily: theme.fonts.main};
    if (name === 'instagramOld') {
        style.color = 'transparent';
        style.background = 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)';
        style.WebkitBackgroundClip = 'text';
        style.backgroundClip = 'text';
    }
    if (name === 'twitterOld') style.color = '#1DA1F2';
    if (name === 'linkedinOld') style.color = '#0077b5';
    return <span style={style} className={className}>{textIcons[name]}</span>;
  }

  return (
    <svg className={className} viewBox={viewBox} width={size} height={size} fill={iconFill} stroke={iconStroke} strokeWidth="1.5" style={propStyle}>
      {iconPaths[name] || <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" fill="currentColor" stroke="none"/>} {/* Default fallback icon */}
    </svg>
  );
};

// --- ANIMATED SECTION WRAPPER ---
const AnimatedSectionWrapper = ({ children, className, customVariants, threshold = 0.15, as = 'section', id, staggerChildren = 0.08, ...props }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold, triggerOnce: true });

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [controls, inView]);

  const defaultVariants = theme.motion.reveal;
  const MotionComponent = motion[as];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: staggerChildren > 0 ? staggerChildren : undefined,
        delayChildren: staggerChildren > 0 ? (customVariants?.visible?.transition?.delayChildren || 0.15) : undefined,
      }
    }
  };

  const itemVariants = customVariants || defaultVariants;

  if (staggerChildren > 0 && React.Children.count(children) > 1) {
    return (
      <MotionComponent
        id={id}
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={containerVariants}
        className={`section-container ${className || ''}`}
        {...props}
      >
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            const isHtmlTag = typeof child.type === 'string';
            const isAlreadyMotionComponent = child.type?.displayName?.startsWith('motion.');

            if (isHtmlTag || (!isAlreadyMotionComponent && typeof child.type === 'function')) {
              // Wrap HTML tags or non-motion functional components
              const MotionChildWrapper = motion[child.type] || motion.div;
              return <MotionChildWrapper key={index} variants={itemVariants} custom={index}>{child.props.children}</MotionChildWrapper>;
            } else if (isAlreadyMotionComponent) {
                // If it's already a motion component, pass variants and custom
                 return React.cloneElement(child, { variants: itemVariants, custom: index, key: child.key || index });
            }
          }
          return child;
        })}
      </MotionComponent>
    );
  }


  return (
    <MotionComponent
      id={id}
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={itemVariants}
      className={`section-container ${className || ''}`}
      {...props}
    >
      {children}
    </MotionComponent>
  );
};


// --- REUSABLE UI COMPONENTS ---
const Button = ({ children, nownfcStyle, secondary, small, className, ...props }) => {
  const buttonClasses = [
    'button',
    nownfcStyle ? 'button--nownfc' : '', // Changed from button--dss
    secondary ? 'button--secondary' : '',
    small ? 'button--small' : '',
    className || ''
  ].filter(Boolean).join(' ');

  return (
    <motion.button className={buttonClasses} {...props}>
      {children}
    </motion.button>
  );
};

const Card = ({ children, dark, glass, className, ...props }) => {
  const cardClasses = [
    'card',
    dark ? 'card--dark' : '',
    glass ? 'card--glass' : '',
    className || ''
  ].filter(Boolean).join(' ');

  return (
    <motion.div className={cardClasses} {...props}>
      {children}
    </motion.div>
  );
};

// CORRECTED AnimatedText Component
const AnimatedText = ({ text, el: ElFromProp = 'span', charVariants = theme.motion.textRevealLetter, containerVariants = theme.motion.textRevealContainer, className, ...props }) => {
  let MotionElToUse;
  if (typeof ElFromProp === 'string') {
    MotionElToUse = motion[ElFromProp];
  } else {
    MotionElToUse = ElFromProp;
  }

  if (!MotionElToUse || typeof MotionElToUse === 'object') {
    console.error(`AnimatedText: Invalid 'el' prop. It resolved to '${MotionElToUse}' for ElFromProp: '${ElFromProp}'. Defaulting to motion.span.`);
    MotionElToUse = motion.span;
  }

  return (
    <motion.div variants={containerVariants} className={className} {...props} style={{display: 'inline-block', ...props.style}}>
      {text.split("").map((char, index) => (
        <MotionElToUse key={`${char}-${index}`} variants={charVariants} style={{display: 'inline-block'}}>
          {char === " " ? "\u00A0" : char}
        </MotionElToUse>
      ))}
    </motion.div>
  );
};

// --- nownfc Logo Component --- Changed from DssLogo
const NownfcLogo = ({ className = "", small = false, style }) => (
  <div className={`nownfc-logo-styled ${small ? 'nownfc-logo-styled--small' : ''} ${className}`} style={style}>
    
  </div>
);

// --- Phone Screen UI Content ---
const PhoneScreenUIT_Content_File1 = ({ isFlatLayout = false }) => (
  <div className="phone-screen-ui">
    <div className="profile-header">
      <div className="profile-pic-placeholder">DSS</div>
      <div className="profile-name-title">
        <h3>Er.DHEERAJ PANWAR</h3>
        <p>nowNFC.com</p> {/* Changed from dss.live */}
      </div>
    </div>
    {!isFlatLayout && (
      <div className="about-section">
        <p><strong>About nownfc Profile</strong></p> {/* Changed from DSS Profile */}
        <p>The revolutionary nownfc card seamlessly transfers your comprehensive contact info to any smartphone. Tap into the future of networking with nownfc.</p> {/* Changed from DSS */}
      </div>
    )}

    {isFlatLayout ? (
      <div className="flat-contacts-row">
        {['phone', 'email', 'website', 'linkedinOld'].map(contactType => (
            <div key={contactType} className="contact-item">
                <span className="icon-placeholder-ui"><Icon name={contactType} size={16}/></span>
                {contactType.replace('Old','').charAt(0).toUpperCase() + contactType.replace('Old','').slice(1)}
            </div>
        ))}
      </div>
    ) : (
      <>
        <p className="connect-via-title"><strong>Connect via</strong></p>
        <div className="contacts-grid">
          {[ 'phone', 'email', 'website', 'linkedin', 'twitter', 'instagram', 'facebook', 'youtube', 'tiktok', 'pinterest', 'address'].map(contactType => (
            <div key={contactType} className="contact-item">
                <span className="icon-placeholder-ui"><Icon name={contactType.replace('Old','')} size={18}/></span>
                {contactType.replace('Old','').charAt(0).toUpperCase() + contactType.replace('Old','').slice(1)}
            </div>
          ))}
        </div>
      </>
    )}

    <div className="phone-buttons-ui">
      <button className="phone-button-ui share">Share Profile</button>
      <button className="phone-button-ui save">Save Contact</button>
    </div>
    <p className="powered-by-text">Powered by nownfc.com</p> {/* Changed from dss.cards */}
  </div>
);

    const services = [
        "Software Development", "Website Development", "App Development",
        "Digital Marketing", "SEO", "Bulk SMS"
    ];
const CustomIcon = () => (
  <svg
    id="Layer_1"
    style={{ enableBackground: 'new 0 0 250.8 312.8',height:'50px', paddingTop:'7px' }}
    version="1.1"
    viewBox="0 0 250.8 312.8"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <style type="text/css">
      {`
        .st0{fill:#3C8BD9;}
        .st1{fill:#FABC04;}
        .st2{fill:#34A852;}
        .st3{fill:#E1C025;}
        .st4{fill:#757575;}
        
      `}
    </style>
    <g>
      <path className="st0" d="M85.9,28.6c2.4-6.3,5.7-12.1,10.6-16.8c19.6-19.1,52-14.3,65.3,9.7c10,18.2,20.6,36,30.9,54c17.2,29.9,34.6,59.8,51.6,89.8c14.3,25.1-1.2,56.8-29.6,61.1c-17.4,2.6-33.7-5.4-42.7-21c-15.1-26.3-30.3-52.6-45.4-78.8c-0.3-0.6-0.7-1.1-1.1-1.6c-1.6-1.3-2.3-3.2-3.3-4.9c-6.7-11.8-13.6-23.5-20.3-35.2c-4.3-7.6-8.8-15.1-13.1-22.7c-3.9-6.8-5.7-14.2-5.5-22C83.6,36.2,84.1,32.2,85.9,28.6"/>
      <path className="st1" d="M85.9,28.6c-0.9,3.6-1.7,7.2-1.9,11c-0.3,8.4,1.8,16.2,6,23.5C101,82,112,101,122.9,120c1,1.7,1.8,3.4,2.8,5c-6,10.4-12,20.7-18.1,31.1c-8.4,14.5-16.8,29.1-25.3,43.6c-0.4,0-0.5-0.2-0.6-0.5c-0.1-0.8,0.2-1.5,0.4-2.3c4.1-15,0.7-28.3-9.6-39.7c-6.3-6.9-14.3-10.8-23.5-12.1c-12-1.7-22.6,1.4-32.1,8.9c-1.7,1.3-2.8,3.2-4.8,4.2c-0.4,0-0.6-0.2-0.7-0.5c4.8-8.3,9.5-16.6,14.3-24.9C45.5,98.4,65.3,64,85.2,29.7C85.4,29.3,85.7,29,85.9,28.6"/>
      <path className="st2" d="M11.8,158c1.9-1.7,3.7-3.5,5.7-5.1c24.3-19.2,60.8-5.3,66.1,25.1c1.3,7.3,0.6,14.3-1.6,21.3c-0.1,0.6-0.2,1.1-0.4,1.7c-0.9,1.6-1.7,3.3-2.7,4.9c-8.9,14.7-22,22-39.2,20.9C20,225.4,4.5,210.6,1.8,191c-1.3-9.5,0.6-18.4,5.5-26.6c1-1.8,2.2-3.4,3.3-5.2C11.1,158.8,10.9,158,11.8,158"/>
      <path className="st1" d="M11.8,158c-0.4,0.4-0.4,1.1-1.1,1.2c-0.1-0.7,0.3-1.1,0.7-1.6L11.8,158"/>
          </g>
  </svg>
);

const CustomIcon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="64px"
    height="64px"
  >
    <defs>
      <style>
        {`
          .cls-1 {
            fill: none;
            stroke: #078cd6;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 2px;
          }
        `}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M54.57,40.19A24,24,0,0,1,9.38,40"
    />
    <path
      className="cls-1"
      d="M9.43,23.78A24,24,0,0,1,54.66,24"
    />
    <path
      className="cls-1"
      d="M42.32,40.33C40.77,49.48,36.73,56,32,56s-8.82-6.61-10.35-15.86"
    />
    <path
      className="cls-1"
      d="M21.6,24C23.09,14.6,27.18,8,32,8s8.85,6.66,10.37,16"
    />
    <rect
      className="cls-1"
      height="16"
      rx="2"
      ry="2"
      width="56"
      x="4"
      y="24"
    />
    <polyline
      className="cls-1"
      points="27.07 29.64 29.53 35.19 32 30.8 34.47 35.19 36.93 29.64"
    />
    <polyline
      className="cls-1"
      points="13.07 29.64 15.53 35.19 18 30.8 20.47 35.19 22.93 29.64"
    />
    <polyline
      className="cls-1"
      points="41.07 29.64 43.53 35.19 46 30.8 48.47 35.19 50.93 29.64"
    />
  </svg>
);



   
const CloudLinkIcon = () => (
  <svg fill="none" height="70" viewBox="0 0 20 20" width="50" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.6469 8.24599C14.4145 5.92329 12.8166 4 10 4C7.18335 4 5.58687 5.90802 5.35314 8.24599L5.28207 8.24599C3.46942 8.24599 2 9.75792 2 11.623C2 13.4881 3.46942 15 5.28205 15H9.03544C9.01209 14.8367 9 14.6698 9 14.5C9 12.567 10.567 11 12.5 11H16.5C17.032 11 17.5364 11.1187 17.9879 11.3311C17.8441 9.60269 16.435 8.24599 14.7179 8.24599L14.6469 8.24599ZM12.5 12C11.1193 12 10 13.1193 10 14.5C10 15.8807 11.1193 17 12.5 17H13C13.2761 17 13.5 16.7761 13.5 16.5C13.5 16.2239 13.2761 16 13 16H12.5C11.6716 16 11 15.3284 11 14.5C11 13.6716 11.6716 13 12.5 13H13C13.2761 13 13.5 12.7761 13.5 12.5C13.5 12.2239 13.2761 12 13 12H12.5ZM16 12C15.7239 12 15.5 12.2239 15.5 12.5C15.5 12.7761 15.7239 13 16 13H16.5C17.3284 13 18 13.6716 18 14.5C18 15.3284 17.3284 16 16.5 16H16C15.7239 16 15.5 16.2239 15.5 16.5C15.5 16.7761 15.7239 17 16 17H16.5C17.8807 17 19 15.8807 19 14.5C19 13.1193 17.8807 12 16.5 12H16ZM12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15H16.5C16.7761 15 17 14.7761 17 14.5C17 14.2239 16.7761 14 16.5 14H12.5Z" fill="#78c2f5"/>
</svg>
);

const ThreadsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Layer_1"
    width="70px"
    height="95px"
    viewBox="0 0 128 128"
    enable-background="new 0 0 128 128"
    style={{ borderRadius: "90%" }} // Apply the 50% radius here
  >
    <g>
      <path
        d="M65.72,65.394c-9.076,0.523-12.087,4.914-11.877,8.849c0.283,5.307,6.018,7.785,11.538,7.474c5.405-0.297,11.539-2.417,12.586-15.479c-2.804-0.613-5.889-0.934-9.185-0.934C67.78,65.305,66.76,65.333,65.72,65.394z"
        fill="#ffff"
      />
      <path
        d="M104.709,0.962H23.291c-12.374,0-22.405,10.031-22.405,22.405v81.266c0,12.374,10.031,22.405,22.405,22.405h81.418c12.374,0,22.405-10.031,22.405-22.405V23.367C127.114,10.993,117.083,0.962,104.709,0.962z M103.066,46.5c-2.224,0.593-4.501-0.631-5.303-2.789c-1.418-3.813-3.273-7.16-5.55-9.962c-6.157-7.576-15.437-11.462-27.585-11.552c-12.061,0.089-21.182,3.957-27.112,11.496c-5.553,7.059-8.423,17.256-8.53,30.307c0.107,13.051,2.977,23.247,8.529,30.304c5.93,7.539,15.052,11.407,27.112,11.496c10.872-0.08,18.066-2.667,24.051-8.646c6.831-6.825,6.704-15.197,4.519-20.291c-1.285-2.996-3.611-5.49-6.75-7.384c-0.764,5.698-2.496,10.22-5.234,13.71c-3.604,4.595-8.772,7.108-15.359,7.469c-4.987,0.272-9.787-0.931-13.513-3.391c-4.407-2.91-6.987-7.363-7.263-12.541c-0.544-10.206,7.554-17.552,20.148-18.278c4.47-0.256,8.653-0.055,12.52,0.603c-0.513-3.14-1.55-5.629-3.101-7.429c-2.13-2.473-5.421-3.741-9.783-3.769c-0.04,0-0.081,0-0.121,0c-2.749,0-6.269,0.604-9.122,3.086c-1.512,1.316-3.733,1.416-5.386,0.282c-2.409-1.652-2.572-5.114-0.378-7.043c3.912-3.439,9.034-5.282,14.882-5.282c0.06,0,0.12,0,0.18,0c13.247,0.085,21.137,8.351,21.92,22.789c0.45,0.193,0.895,0.395,1.332,0.605c6.181,2.966,10.701,7.455,13.073,12.983c3.305,7.708,3.607,20.264-6.42,30.281c-7.664,7.657-16.967,11.112-30.164,11.203h-0.059c-14.845-0.102-26.26-5.098-33.929-14.847c-6.824-8.675-10.344-20.746-10.462-35.877V64v-0.036c0.118-15.131,3.638-27.202,10.462-35.877c7.669-9.749,19.084-14.744,33.929-14.847h0.059c14.875,0.103,26.419,5.079,34.313,14.791c2.981,3.667,5.357,7.912,7.123,12.708C106.987,43.165,105.563,45.834,103.066,46.5z"
        fill="#ffff"
      />
    </g>
  </svg>
);


// --- NEW PHONE MOCKUP COMPONENT ---
const DheerPhoneMockup = () => {
    const services = [
        "Software Development", "Website Development", "App Development",
        "Digital Marketing", "SEO", "Bulk SMS"
    ];

    return (
        <div className="mobile-mockup">
            <div className="status-bar">
                <span>3:51</span>
                <div className="status-bar-icons">
                    <FontAwesomeIcon icon={faSignal} />
                    <FontAwesomeIcon icon={faWifi} />
                    <FontAwesomeIcon icon={faBatteryFull} />
                </div>
            </div>
            <div className="mockup-content">
                <div className="card-container">
                    <header 
                        className="header" 
                        style={{ backgroundImage: `url(${headerBgImage})` }} 
                    />
                    <div className="logo-container">
                        <img src={logoImage} alt="Dheer Software Solutions Logo" className="logo" />
                    </div>
                    <main>
                        <div className="profile-info">
                            <h1 className="profile-title">Er. Dheeraj Panwar</h1>
                            <span className="profile-subtitle">CEO & MD</span><br/>
                            <span className="profile-subtitle">DHEER SOFTWARE SOLUTIONS</span>
                        </div>

                        <section className="section section-left">
                            <h2 className="section-title" style={{marginTop:'30px'}}>About Us</h2>
                            <p className="about-text">Dheer Software Solutions offers innovative, custom-built software tailored to your business needs.</p>
                            <div className="btn-group">
                                <a href="#!" className="btn">Download Contact</a>
                                <a href="#!" className="btn">Share Contact</a>
                            </div>
                        </section>

                        <section className="section section-left">
                            <h2 className="section-title" style={{marginTop:'30px'}}>Services</h2>
                            <ul className="services-list">
                                {services.map(service => (
                                    <li key={service} className="service-item">
                                        {service} <span className="service-circle"></span>
                                    </li>
                                ))}
                            </ul>
                            <div style={{ textAlign: 'left'  }}>
                                <a href="#!" className="btn">Download Brochure</a>
                            </div>
                        </section>

                        <section className="section">
                            <h2 className="section-title"  style={{marginTop:'30px'}}>Phone Messenger & Email</h2>
                            <div className="icon-grid" style={{marginTop:'30px'}}>
                                <a href="tel:+91-YOUR-NUMBER" className="icon-link"><FontAwesomeIcon icon={faPhone} className="icon-phone" /></a>
                                <a href="#!" className="icon-link"><FontAwesomeIcon icon={faFacebookMessenger} className="icon-messenger" /></a>
                                <a href="https://wa.me/91YOURNUMBER" className="icon-link"><FontAwesomeIcon icon={faWhatsapp} className="icon-whatsapp" /></a>
                                <a href="mailto:dheersoftwaresolutions@gmail.com" className="icon-link"><FontAwesomeIcon icon={faEnvelope} className="icon-envelope" /></a>
                             
                            </div>
                        </section>
                        
                        <section className="section">
                            <h2 className="section-title"  style={{marginTop:'30px'}}>Address & Location</h2>
                            <iframe 
                              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.650227160415!2d73.03423637595647!3d26.305436685923194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418da713ff71dd%3A0x5768d9cadeae412c!2sDheer%20Software%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1752133437900!5m2!1sen!2sin"
                                allowFullScreen="" 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Dheer Software Solutions Location"
                            ></iframe>
                        </section>

                        <section className="section">
                            <h2 className="section-title" style={{marginTop:'30px'}} >Website & Links</h2>
                            <div className="icon-grid" style={{marginTop:'30px'}}>
                                <a href="https://dheersoftwaresolutions.com/" target="_blank" rel="noopener noreferrer" className="icon-link"><CustomIcon2 className="icon-default" /></a>
                                <a href="#!" className="icon-link" ><CustomIcon className="icon-default" /></a>
                                <a href="#!" className="icon-link"><FontAwesomeIcon icon={faFileLines} className="icon-default" /></a>
                                <a href="#!" className="icon-link"><CloudLinkIcon className="icon-default" /></a>
                            </div>
                        </section>
                        <section className="section section-social">
                            <h2 className="section-title" style={{marginTop:'30px'}}>Social Links</h2>
                            <div className="social-icon-grid" style={{marginTop:'30px'}}>
                          <div className="footernfc-social-media-icons-uniques">
                                                       <a href="https://instagram.com/nownfcofficial" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                                                       <a href="https://linkedin.com/company/nownfcofficial" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                                                       <a href={`https://wa.me/91631516`} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faWhatsapp} /></a>
                                                       <a href="https://youtube.com/@NowNFCofficial" aria-label="YouTube" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                                                       <a href="https://facebook.com/nownfcofficial" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} /></a>
                                                          <a href="mailto:dheersoftwaresolutions@gmail.com" className="icon-link"><ThreadsIcon  className="icon-envelope" /></a>
                                                   </div>  </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    );
};


// --- SECTION ONE: BUSINESS CARD TALK ---
const SectionOneBusinessCardTalk = () => {
  return (
    <AnimatedSectionWrapper
      as="section"
      id="card-features"
      className="section-one-styled dss-section-padding" // Retained dss-section-padding for layout
      staggerChildren={0.1} // Enable staggering for direct children
    >
      <div className="top-swoosh"></div>
      <motion.div className="section-one-content" variants={theme.motion.reveal}>
        <motion.h2 className="main-headline text-center" variants={theme.motion.reveal}> No More Boring Cards<br/> <span>Let Your NFC Card  Speak for You.</span></motion.h2>
        <div className="presentation-area">
             <motion.div className="nownfc-card-large-mockup" variants={theme.motion.reveal}>
          
            <img src={image5} alt="Professional showcasing nownfc card profile" />
          </motion.div>
          <motion.div className="person-image-container" variants={theme.motion.reveal}>
          
            <img src={image12} alt="Professional showcasing nownfc card profile" />
          </motion.div>
           <motion.div className="phone-wrapper" variants={theme.motion.reveal}>
                       <DheerPhoneMockup />
                    </motion.div>
          
          
        </div>
        
        <motion.div variants={theme.motion.reveal}><NownfcLogo /></motion.div>
      </motion.div>
      <div className="bottom-swoosh"></div>
    </AnimatedSectionWrapper>
  );
};

// --- SECTION TWO: BRAG-O WITH nownfc (RE-STYLED PER REQUEST) ---
const SectionTwoBragONownfc = () => {
    const speakerDots = Array(6).fill(null);

    return (
        <AnimatedSectionWrapper as="section" id="section-two-brag-o-nownfc" className="section-two-styled dss-section-padding" staggerChildren={0}>
          <motion.h2 className="secondary-headline" variants={theme.motion.reveal} >
                        Where Technology Becomes Your Identity.
                    </motion.h2>
            <div className="section-two-content-grid">
                <motion.div className="visuals-column" variants={theme.motion.reveal}>
                    <div className="cards-and-phone-display">
                        <motion.div className="cards-row" variants={{visible: { transition: { staggerChildren: 0.1 }}}}>
                            <motion.div className="nownfc-card-mockup nfc-card-design" variants={theme.motion.reveal}>
                                <div className="nfc-logo-container">
                                    <Icon name="nfcSignal" size={36} color="#ced4da" style={{ filter: 'drop-shadow(0 0 2.5px rgba(206,212,218,0.45))' }} />
                                </div>
                                <NownfcLogo className="card-nownfc-logo" />
                            </motion.div>
                            <motion.div className="nownfc-card-mockup white-card-design" variants={theme.motion.reveal}>
                                <div>
                                    <NownfcLogo className="card-nownfc-logo" />
                                    <p className="card-url">nownfc.com/yourlink</p>
                                </div>
                                <div className="abstract-design-container">
                                    <div className="abstract-swoosh-1"></div>
                                    <div className="abstract-swoosh-2"></div>
                                    <div className="abstract-dots"></div>
                                </div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="phone-mockup-flat" variants={theme.motion.reveal}>
                            <div className="phone-screen">
                                <div className="dynamic-island"></div>
                                <div className="phone-screen-scrollable-content">
                                    <PhoneScreenUIT_Content_File1 isFlatLayout={true} />
                                </div>
                            </div>
                            <div className="speaker-grille left">
                                {speakerDots.map((_, index) => <div key={`left-dot-${index}`} className="speaker-dot"></div>)}
                            </div>
                            <div className="speaker-grille right">
                                {speakerDots.map((_, index) => <div key={`right-dot-${index}`} className="speaker-dot"></div>)}
                            </div>
                        </motion.div>
                    </div>
                </motion.div>

                <motion.div className="text-column" variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.1, delayChildren: 0.2 } } }}>
                    
                      <motion.div className="nfc-info-text" variants={theme.motion.reveal}>
                          <h4>One Tap to Share Everything.</h4>
                          {/* <p>
                              Ditch outdated paper cards. A single tap of your nownfc card on a smartphone instantly shares your profile, socials, and websites, creating an unforgettable, modern first impression.
                          </p> */}
                          <ul className="benefits-list">
                              {[
                                  "Always Up-to-Date",
                                  "Unforgettable Impression",
                                  "Eco-Friendly & Sustainable",
                                  "No App Needed for Recipient"
                              ].map((benefit, index) => (
                                  <motion.li key={index} variants={theme.motion.reveal}>
                                      <Icon name="checkCircle" size={22} color={theme.colors.textAgainstDark} style={{opacity: 0.8}} />
                                      <span>{benefit}</span>
                                  </motion.li>
                              ))}
                          </ul>
                      </motion.div>
                </motion.div>
            </div>
        </AnimatedSectionWrapper>
    );
};

// --- ABOUT NFC SECTION ---
const AboutNFCSection = () => {
  const benefits = [
    { icon: 'metal', title: 'Instantaneous Sharing', description: 'Exchange contacts, socials, websites, and more with a single, magical tap. No apps, no fuss for recipients when using nownfc cards.' },
    { icon: 'bolt', title: 'Elevate Your Brand', description: 'Impress clients and partners with a cutting-edge, memorable first impression. nownfc reimagines networking.' },
    { icon: 'settings', title: 'Dynamically Yours', description: 'Your info is alive! Update your nownfc digital hub anytime, and changes instantly reflect on your card.' },
    { icon: 'shield', title: 'Sustainable & Secure', description: 'Ditch paper waste with a durable, eco-conscious nownfc card. Your data is protected with modern security standards.' },
  ];

  return (
    <AnimatedSectionWrapper as="section" id="about-nfc" className="about-nfc-container" staggerChildren={0.05}>
        <div className="section-content-wrapper">
          
               
                <motion.h2 className="secondary-headline" variants={theme.motion.reveal} >
                       Unleash NFC Power with nownfc 
                    
            </motion.h2>
            <motion.p className="section-subtitle text-center" variants={theme.motion.reveal}>
                Near Field Communication (NFC) isn't just tech it's your new networking superpower. See how nownfc transforms fleeting moments into lasting connections.
            </motion.p>
            <motion.div className="about-nfc-grid" variants={{ visible: { transition: { staggerChildren: 0.1 } } }}>
                <Card className="info-card info-card--nownfc-brand-style about-nfc-grid__main-card" variants={theme.motion.reveal}>
                <div className="info-card-header">
                    <div className="icon-wrapper"><Icon name="tap"/></div>
                    <h4>The NowNFC Magic?</h4>
                </div>
                <p>A nownfc NFC card embeds a tiny chip and antenna, speaking fluently with NFC-enabled devices (yes, most modern smartphones!). A simple tap can launch your digital business card, website, or social kingdom, instantly captivating your audience.<br/></p> <p>Unlock the future with a single tap.
NowNFC cards embed a smart chip and antenna that connect instantly with NFC-enabled smartphones — no apps, no QR codes, just pure, seamless interaction.

Launch your digital business card, portfolio, or social links in a flash.
Update anytime. Share anywhere. Impress every time.

One card. Endless possibilities.<br/>
Tap. Connect. Inspire.</p>
                </Card>

                <Card className="visual-explanation-container about-nfc-grid__visual-card" variants={theme.motion.reveal}>
                    <motion.img
                        src={image10}
                        alt="Phone tapping an NFC card reader to display digital profile"
                        whileHover={{scale: 1.04, y: -3}}
                        transition={theme.motion.springQuick}
                    />
                    <p>Tap. Connect. Conquer. It’s the nownfc way.</p>
                </Card>

                {benefits.map((benefit) => (
                <Card key={benefit.title} className="info-card info-card--nownfc-brand-style" variants={theme.motion.reveal}>
                    <div className="info-card-header">
                    <div className="icon-wrapper"><Icon name={benefit.icon}/></div>
                    <h4>{benefit.title}</h4>
                    </div>
                    <p>{benefit.description}</p>
                </Card>
                ))}
            </motion.div>
        </div>
    </AnimatedSectionWrapper>
  );
};

// --- HOW IT WORKS SECTION ---
const HowItWorksSection = () => {
  const steps = [
    { number: "01", icon: "palette", title: "Design Your Vision", description: "Choose your nownfc card material, upload your logo, and personalize your digital profile to perfection." },
    { number: "02", icon: "truck", title: "Crafted & Delivered", description: "We meticulously craft your premium nownfc NFC card and ship it straight to your doorstep, ready to impress." },
    { number: "03", icon: "tap", title: "Tap into Brilliance", description: "Effortlessly share your world with a simple tap. Watch connections spark and opportunities unfold with nownfc." },
    { number: "04", icon: "settings", title: "Evolve & Conquer", description: "Your nownfc digital presence is dynamic. Update your profile anytime, anywhere, keeping you always ahead." },
  ];
  return (
    <AnimatedSectionWrapper as="section" id="how-it-works" className="how-it-works-container" staggerChildren={0.05}>
        <div className="section-content-wrapper">
            
              <motion.h2 className="secondary-headline" variants={theme.motion.reveal} >
                      Simplicity Meets Sophistication
                    
            </motion.h2>
            <motion.p className="section-subtitle text-center" variants={theme.motion.reveal}>
                Getting started with nownfc is a breeze. Follow these simple steps to transform your networking game.
            </motion.p>
            <motion.div className="how-it-works-grid" variants={{visible: {transition: {staggerChildren: 0.1}}}}>
                {steps.map(step => (
                    <Card key={step.number} className="step-card" variants={theme.motion.reveal}>
                        <div className="step-number">{step.number}</div>
                        <div className="icon-wrapper"><Icon name={step.icon}/></div>
                        <h3>{step.title}</h3>
                        <p>{step.description}</p>
                    </Card>
                ))}
            </motion.div>
        </div>
    </AnimatedSectionWrapper>
  );
};

// --- Dashboard Section ---
const DashboardSection = () => {
  return (
    <AnimatedSectionWrapper as="section" id="business-solutions" className="dashboard-section-styled dss-section-padding" staggerChildren={0.1}>
        <div className="section-content-wrapper">
            <motion.h2 className="headline" variants={theme.motion.reveal}>Unified Command Center for Your Team's <span >Digital Identity</span></motion.h2>
            <motion.p className="subhead" variants={theme.motion.reveal}>Seamlessly manage multiple dynamic nownfc cards for your entire team. One dashboard, total control, effortless brand consistency across all touchpoints.</motion.p>
            <motion.div className="dashboard-mockup" variants={theme.motion.reveal}><img src={dssDashboardMockupUrl} alt="nownfc Team Dashboard Mockup for managing multiple cards"/></motion.div>
            <motion.div variants={theme.motion.reveal}><a href='/features' target='_blank'><Button nownfcStyle className="btn-hover-float">Explore Business Solutions</Button></a></motion.div>
            <motion.p className="microcopy" variants={theme.motion.reveal}>Empower your team with the future of networking. Contact us for a demo.</motion.p>
        </div>
    </AnimatedSectionWrapper>
  );
};

// --- Enhanced Networking Section (MODIFIED PER REQUEST) ---
const EnhancedNetworkingSection = () => {
   return (
    <AnimatedSectionWrapper as="section" id="enhanced-networking" className="enhanced-networking-section-styled dss-section-padding enhanced-networking-section" staggerChildren={0}>
      <motion.div className="image-container enhanced-networking-image" variants={theme.motion.reveal}>
        <div className="card-base dark-card" style={{ backgroundImage: `url(${image1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
           
        </div>
        <div className="card-base light-card" style={{ backgroundImage: `url(${image2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
           
        </div>
      </motion.div>
      <motion.div className="text-container enhanced-networking-text responsive-text-center" variants={theme.motion.reveal}>
        <h2 className="headline">Connect Beyond Limits, Instantly with nownfc</h2>
        <p className="subhead">NFC tap, QR scan, or a direct link—nownfc offers versatile sharing for every scenario. Make instant, impactful connections, effortlessly. No apps, no fuss for anyone.</p>
        <a href='/features' target='_blank'><Button nownfcStyle className="btn-hover-float">Explore Sharing Options</Button></a>
        <div className="micro-icons-container responsive-cta-center">
            <Icon name="qr" size={20} /> Tap  <Icon name="scan" size={20}/> Scan <Icon name="link" size={20}/> Link
        </div>
      </motion.div>
    </AnimatedSectionWrapper>
   );
};

// --- Stronger Connection Section (HEAVILY MODIFIED) ---
const StrongerConnectionSection = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const phoneOrder = ['profile', 'gallery', 'video'];
  const phoneContents = {
    profile: { image: strongerConnectionPhoneImages.profile, alt: "Professional Profile on nownfc Card", title: "Alex Chen", details: "CEO & Founder, Tech Innovators Inc." },
    gallery: { image: strongerConnectionPhoneImages.gallery, alt: "Project Gallery on nownfc Card", title: "Award-Winning Designs", details: "Explore our portfolio of stunning visuals." },
    video: { image: strongerConnectionPhoneImages.video, alt: "Company Video on nownfc Card", title: "Our Story in Motion", details: "Discover the passion behind nownfc." },
  };

  const getPhoneDynamicStyle = (phoneKey) => {
    const currentIndex = phoneOrder.indexOf(phoneKey);
    const activeIndex = phoneOrder.indexOf(activeTab);
    let diff = currentIndex - activeIndex;
    if (diff > 1) diff = -1; if (diff < -1) diff = 1;

    let baseTransform = '', opacity = 0.4, zIndex = 1;
    if (diff === 0) {
        baseTransform = 'translateY(-10px) scale(1.1) translateZ(80px) rotateX(0deg) rotateY(0deg)';
        opacity = 1;
        zIndex = 3;
    } else if (diff === -1) {
        baseTransform = 'translateX(-120px) scale(0.85) translateZ(-50px) rotateY(25deg) rotateX(4deg)';
        zIndex = 2;
    } else { // diff === 1
        baseTransform = 'translateX(120px) scale(0.85) translateZ(-50px) rotateY(-25deg) rotateX(4deg)';
        zIndex = 2;
    }

    return { transform: baseTransform, opacity, zIndex, 'data-pos-diff': diff };
  };

  const tabs = [
    {id: 'profile', label: 'Rich Digital Profiles'},
    {id: 'gallery', label: 'Stunning Galleries'},
    {id: 'video', label: 'Fully Customizable Layouts'}
  ];

  return (
    <AnimatedSectionWrapper as="section" id="rich-profiles" className="stronger-connection-section-styled dss-section-padding responsive-flex-column stronger-connection-section" staggerChildren={0}>
      <motion.div className="text-container stronger-connection-text" variants={theme.motion.reveal}>
        <h2 className="headline">Craft Connections That Truly Resonate</h2>
        <p className="subhead">
            Go beyond the ordinary with NowNFC. Transform quick introductions into powerful, lasting impressions. With every tap, your card delivers a fully immersive digital experience—professionally designed to impress, inform, and inspire.
        </p>
        <div className="tabs-container">
          {tabs.map(tab => (
            <button key={tab.id} className={`tab-button btn-tab-hover-stronger ${activeTab === tab.id ? 'active' : ''}`} onClick={() => setActiveTab(tab.id)}>
                {tab.label}
            </button>
          ))}
        </div>
        <Button nownfcStyle className="btn-hover-float"><a href='/login' style={{color:'white', textDecoration:'none'}}>Build Your Rich nownfc Profile</a></Button>
      </motion.div>
      <motion.div className="images-container stronger-connection-images phone-mockup-gallery-interactive" variants={theme.motion.reveal}>
        {phoneOrder.map(key => (
          <div
            key={key}
            className="phone-mockup-base gallery-phone-interactive"
            style={getPhoneDynamicStyle(key)}
            onClick={() => setActiveTab(key)} // <-- CLICK HANDLER ADDED HERE
          >
            <div className="phone-screen-wrapper">
              <img src={phoneContents[key].image} alt={phoneContents[key].alt} className="phone-bg-image phone-bg-zoom"/>
              {/* <div className="phone-screen-overlay">
                <h4 className="phone-screen-title">{phoneContents[key].title}</h4>
                <p className="phone-screen-details">{phoneContents[key].details}</p>
              </div> */}
            </div>
          </div>
        ))}
      </motion.div>
    </AnimatedSectionWrapper>
  );
};

// --- Works On All Phones Section ---
const WorksOnAllPhonesSection = () => {
  const microFeatures = [
    { icon: 'nfc', text: 'NFC-Enabled Tap & Go' }, { icon: 'qr', text: 'Universal QR Compatibility' },
    { icon: 'scratch', text: 'Durable, Premium Finish' }, { icon: 'secure', text: 'Secure Data Encryption' }
  ];
  return (
    <AnimatedSectionWrapper as="section" id="works-on-all-phones" className="works-on-all-phones-section-styled dss-section-padding" staggerChildren={0.05}>
        <div className="section-content-wrapper">
            <motion.h2 className="title" variants={theme.motion.reveal}>Universal Access, Premium Durability</motion.h2>
            <motion.p className="copy" variants={theme.motion.reveal}>nownfc cards work flawlessly with any modern smartphone via NFC or QR—no app needed for recipients. Built to last, designed to impress.</motion.p>
            <motion.div className="images-container" variants={{visible: {transition: {staggerChildren: 0.1}}}}>
                <motion.div className="image-placeholder" variants={theme.motion.reveal}>
                <h3>Standard Credit Card Size</h3>
                <p>3.370" × 2.125" (85.6mm × 53.98mm)</p>
                <Icon name="cardStack" size={38} />
                </motion.div>
                <motion.div
                className="image-placeholder image-bg-placeholder"
                variants={theme.motion.reveal}
                style={{ backgroundImage: `url(${image11})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                >
                </motion.div>
            </motion.div>
            <motion.div className="features-grid" variants={{visible: {transition: {staggerChildren: 0.08}}}}>
                {microFeatures.map(feature => (
                <motion.div key={feature.text} className="feature-item feature-item-hover-subtle" variants={theme.motion.reveal}>
                    <Icon name={feature.icon} size={34} />
                    <span>{feature.text}</span>
                </motion.div>
                ))}
            </motion.div>
            <motion.div variants={theme.motion.reveal}><Button nownfcStyle className="btn-hover-float"><a href='/booking' style={{color:'white'}}>Order Your Custom nownfc Cards </a></Button></motion.div>
        </div>
    </AnimatedSectionWrapper>
  );
};

// --- GIF Feature Section ---
const GifFeatureSection = () => {
  const features = [
    { icon: 'scratch', text: 'Premium Scratch-Resistant Matte Finish' }, { icon: 'nfc', text: 'High-Performance Embedded NFC Chip' },
    { icon: 'qr', text: 'Crystal-Clear Instant QR Scanning' }, { icon: 'settings', text: 'Dynamic Content, Seamless Updates' }
  ];
  return (
    <AnimatedSectionWrapper as="section" id="shop" className="gif-feature-section-styled dss-section-padding" staggerChildren={0.05}>
      <div className="section-content-wrapper">
        <motion.video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="gif-image" 
          variants={theme.motion.reveal}
        >
          <source src={featureVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </motion.video>
      <motion.h2 className="headline" variants={theme.motion.reveal}>Simplicity in Action. Power in Your Hand.</motion.h2>
        <motion.p className="short-line" variants={theme.motion.reveal}>Our premium matte-finish nownfc card: durable, elegant, and incredibly easy to use. Tap or scan to instantly share your world.</motion.p>
        <motion.div className="icon-grid" variants={{visible: {transition: {staggerChildren: 0.08}}}}>
            {features.map(feature => (
            <motion.div key={feature.text} className="icon-item feature-item-hover-subtle" variants={theme.motion.reveal}>
                <Icon name={feature.icon} size={34} />
                <span>{feature.text}</span>
            </motion.div>
            ))}
        </motion.div>
        <motion.div variants={theme.motion.reveal}><a href='/pricing' target='_blank'><Button  nownfcStyle style={{ background: theme.colors.dssGradient }} className="btn-hover-float">Shop nownfc Cards Now</Button></a></motion.div>
      </div>
    </AnimatedSectionWrapper>
  );
};



// --- CONTACT CTA SECTION ---
const ContactCTASection = () => {
  return (
    <AnimatedSectionWrapper as="section" id="get-started" className="contact-cta-container" staggerChildren={0.1}>     
          <motion.h2 className="fontchange">Ready to Redefine <br/> Your Network with NowNFC?</motion.h2>
            <motion.p variants={theme.motion.reveal}>
        Join a league of forward-thinkers transforming connections with nownfc. Your custom NFC card awaits—make every introduction an event.
      </motion.p>
      <motion.div variants={theme.motion.reveal} style={{display: 'flex', gap: theme.spacing.md, justifyContent: 'center', flexWrap: 'wrap'}}>
        <Button style={{background: '#007ebc', color: 'rgb(255 255 255)', padding: '18px 38px', fontSize: '17px'}} whileHover={{scale: 1.05, y: -3}} transition={theme.motion.springQuick} className="btn-hover-float"><a href='/pricing' style={{color:'white'}}>Order Your Card Today </a><Icon name="arrowRight" size={19} style={{marginLeft: '5px'}}/></Button>
        <Button secondary style={{borderColor: theme.colors.textAgainstDark, color: theme.colors.textAgainstDark, background: 'transparent', padding: '16px 36px', fontSize: '17px'}} whileHover={{scale: 1.05, y: -3, background: 'rgba(255,255,255,0.12)'}} transition={theme.motion.springQuick} className="btn-hover-outline"><a href='/contact' style={{color:'black'}}>Consult Our Experts</a></Button>
      </motion.div>
    </AnimatedSectionWrapper>
  );
};


// --- MAIN APP COMPONENT ---
function App() {
  return (
    <ThemeProvider theme={theme}>
      <SubtleBgPatternFixed />
      <GlobalNoiseOverlay />
      <main>
        <Hero/>
        <SectionOneBusinessCardTalk />
        <SectionTwoBragONownfc />
        <AboutNFCSection />
        <HowItWorksSection />
        <DashboardSection />
        <EnhancedNetworkingSection />
        <StrongerConnectionSection />
        <WorksOnAllPhonesSection />
        <GifFeatureSection />
        {/* <PricingSection /> */}
        <ContactCTASection />
      </main>
    </ThemeProvider>
  );
}

export default App;